import { render, staticRenderFns } from "./top-menu.vue?vue&type=template&id=6edd555c&scoped=true&"
import script from "./top-menu.vue?vue&type=script&lang=js&"
export * from "./top-menu.vue?vue&type=script&lang=js&"
import style0 from "./top-menu.vue?vue&type=style&index=0&id=6edd555c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edd555c",
  null
  
)

export default component.exports